import clsx from "clsx";
import useTableColumnBuilder from "hooks/useTableColumnBuilder";
import { SBTranslate } from "i18n";
import { SBBox, SBIcon } from "modules/Commons";
import { IForecastModifierConfig } from "./ForecastModifierConfig";
import { useStyles } from "./style";

export const useForecastModifierHeaders = () => {
	const classes = useStyles();

	const {
		add,
		build,
		dateFormatter,
		decimalFormatter,
	} = useTableColumnBuilder<IForecastModifierConfig>();

	add({
		id: () => "modifier",
		name: "modifier",
		hideToggle: true,
		headers: [
			{
				id: (e) => (
					<SBBox className={clsx(classes.editIconBox)}>
						<SBIcon icon="edit" />
					</SBBox>
				),
				align: "center",
				csvHide: true,
				width: 1,
				key: "edit",
				name: "",
				fixed: true,
			},
			{
				id: (e) => e.name,
				csvName: `${SBTranslate("name")}`,
				width: 700,
				align: "left",
				key: "modifierName",
				name: "name",
				tip: "",
			},
		],
	});
	add({
		id: () => "config",
		name: "config",
		headers: [
			{
				id: (c) => c.startDate,
				key: "startDate",
				name: "startDate",
				width: 242,
				align: "left",
				csvName: `${SBTranslate("startDate")}`,
				formatter: dateFormatter,
				tip: "",
			},
			{
				id: (c) => c.endDate,
				key: "endDate",
				name: "endDate",
				width: 242,
				align: "left",
				csvName: `${SBTranslate("endDate")}`,
				formatter: dateFormatter,
				tip: "",
			},
			{
				id: (e) =>
					e.operationType == 1 ? SBTranslate("additive") : SBTranslate("multiplicative"),
				csvName: `${SBTranslate("operation")}`,
				key: "operation",
				name: "operation",
				width: 242,
				align: "left",
				tip: "",
			},
			{
				key: "modifier",
				id: (e) => e?.modifier,
				csvName: `${SBTranslate("modifier")}`,
				width: 85,
				align: "right",
				name: "modifier",
				formatter: decimalFormatter,
				tip: "",
			},
		],
	});

	return build();
};
